import { InboxAccessBits } from "entities/domain/inbox";
import { ConversationTab } from "redux/features/conversations";

/**
 * The tab the inbox opens on when the URL names none: All when the scope
 * offers colleagues' conversations and the merchant has a single agent,
 * otherwise Personal. `access` is what the scope offers
 * (util/inbox-access scopeInboxAccess): one Inbox's capabilities, or any
 * Inbox's for All Inboxes.
 */
export const defaultConversationTab = (
  access: InboxAccessBits,
  agentCount: number
): ConversationTab =>
  access.others && agentCount === 1
    ? ConversationTab.Team
    : ConversationTab.Personal;

/**
 * Whether the default must wait for the Inbox list: only a grant could still
 * offer All to a single adviser whose role does not. Every other case is
 * decided by what is known now.
 */
export const isDefaultConversationTabPending = (
  access: InboxAccessBits,
  agentCount: number,
  isAccessKnown: boolean
): boolean => agentCount === 1 && !access.others && !isAccessKnown;

// The same search with the Personal tab: for a lens the scope does not offer.
export const searchParamsWithPersonalTab = (
  params: URLSearchParams
): URLSearchParams => {
  const next = new URLSearchParams(params);
  next.set("tab", ConversationTab.Personal);
  return next;
};
